/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  HeaderService,
  IHeaderMethods,
  IStaticPageContentMethods,
  StaticPageContentService,
  ISalesCostumeInventoryMethods,
  SalesCostumeInventoryService,
  IPresentationListsMethods,
  PresentationListsService,
} from "./components";

export type SalesStatReportPageAgent = IHeaderMethods &
  IStaticPageContentMethods &
  ISalesCostumeInventoryMethods &
  IPresentationListsMethods;

const getPlugins = () => {
  return [
    new StaticPageContentService(),
    new HeaderService(),
    new PresentationListsService(),
    new SalesCostumeInventoryService(),
  ];
};

export const getAgent = () => {
  return createAgent<SalesStatReportPageAgent>({
    plugins: getPlugins(),
  });
};
